import React from "react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import { Box, Text } from "@chakra-ui/react"
import ConfigBlock from "pages/EventShow/Forms/StyleAndConfiguration/ConfigBlock"
import ImageUpload from "components/ReactHookForm/ImageUpload"
import UpgradeAlert from "components/elements/UpgradeAlert"
import useCurrentPlanType from "utilities/useCurrentPlanType"
import { DioboxEvent } from "sharedTypes"
import extendFormValuesWithImages from "utilities/extendFormValuesWithImages"
import ImageUploadComponent from "components/ImageUploadComponent"
import ModalContentWrapper from "./ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const PageLogoModal = ({
  onHide,
  event: {
    portalShowLogo,
    portalLogoUrl,
    whiteLabel,
  },
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const { corporateFeaturesEnabled } = useCurrentPlanType()

  const values = {
    portalShowLogo,
    portalLogoUrl,
    notWhiteLabel: !whiteLabel,
  }

  const updateEventWithNoWhiteLabel = (data) => {
    const { notWhiteLabel, ...eventToUpdate } = data
    eventToUpdate.whiteLabel = !notWhiteLabel

    return updateEvent(eventToUpdate)
  }

  const handleSubmit = async (data) => {
    await updateEventWithNoWhiteLabel(data)
    onHide()
  }

  const handleCancel = () => {
    onResetEventWorkingCopy()
    onHide()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={extendFormValuesWithImages(values, ["portalLogo"])}
      title="Page Logo"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
    >
      {({ control, watch }) => {
        const enabled = watch("portalShowLogo")

        return (
          <ModalContentWrapper>
            <ConfigBlock title="Enabled" switchName="portalShowLogo" control={control} disabled={!corporateFeaturesEnabled}>
              <Box mb={7}>
                <Text>
                  Personalize your Guest Portal and confirmation pages with your
                  brand&apos;s logo.
                </Text>
              </Box>
              <Box mt={4}>
                <ImageUpload
                  name="portalLogo"
                  control={control}
                  imageWidth="auto"
                  imageHeight={12}
                  imageUrl={portalLogoUrl ? `${portalLogoUrl}?w=320` : ""}
                  Component={UploadComponent}
                  disabled={!enabled || !corporateFeaturesEnabled}
                />
                <Text color="gray.500" fontSize="sm">
                  For best results, upload a transparent PNG (320 × 132 px). Supports PNG
                  and JPG formats, up to 1 MB.
                </Text>
              </Box>
              {!corporateFeaturesEnabled && <Box mt={4}><UpgradeAlert noBorder text="Requires Corporate Subscription" /></Box>}
            </ConfigBlock>
          </ModalContentWrapper>
        )
      }}
    </ModalForm>
  )
}

const UploadComponent = (props) => <ImageUploadComponent {...props} uploadButtonText="Upload Logo" removeButtonText="Remove" />

export default PageLogoModal
